import { render, staticRenderFns } from "./CreatePostPhotosUploading.vue?vue&type=template&id=82b0840c&scoped=true&"
import script from "./CreatePostPhotosUploading.vue?vue&type=script&lang=js&"
export * from "./CreatePostPhotosUploading.vue?vue&type=script&lang=js&"
import style0 from "./CreatePostPhotosUploading.vue?vue&type=style&index=0&id=82b0840c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b0840c",
  null
  
)

export default component.exports